import { createActionFactoryForFeature, Feature, ThunkDispatch } from '../../shared';
import { lpcLeaveGroupCompleted } from '../../hub';
import { MemberManagementScenarios } from '@o365groups/gmc-types';

const actionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);
export const memberManagementCompletedAction = actionFactory<{
    groupId: string;
    groupEmailAddress: string;
    hubPersonaId: string;
}>('MemberManagementCompletedAction');

export const memberManagementCompleted = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupEmailAddress: string,
    hubPersonaId: string,
    operationName: MemberManagementScenarios,
    isSelf: boolean
) => {
    if (operationName === MemberManagementScenarios.RemoveGroupMember && isSelf) {
        dispatch(lpcLeaveGroupCompleted(hubPersonaId));
    } else {
        dispatch(
            memberManagementCompletedAction({
                groupId,
                groupEmailAddress,
                hubPersonaId,
            })
        );
    }
};

export type { Action } from '../../shared';
